module.exports = __webpack_public_path__ + "img/portrait-104.233e959d.jpg";